module.exports = __webpack_public_path__ + "static/media/bowling-ball.7c4e2f6d.svg";